import React, { FunctionComponent } from 'react';
import { BaseSVGProps } from '../icon.types';

const PlusIcon: FunctionComponent<BaseSVGProps> = ({ width, height }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height={height}
        width={width}
        viewBox="0 0 24 24"
    >
        <path d="M24 13.65v-3.3l-10.42.07L13.65 0h-3.3l.07 10.42L0 10.35v3.3l10.42-.08L10.35 24h3.3l-.07-10.43z" />
    </svg>
);

export default PlusIcon;
